import React from "react";
import { useRouteError } from "react-router-dom";
import { useNavigate } from 'react-router-dom';
import Header from '../components/Nav/Header.tsx';
import Card from '../components/Structure/Card.tsx';
import Button from '../components/Form/Button.tsx';

export default function ErrorPage() {
    const error = useRouteError();
    const navigate = useNavigate();

    return (
        <>
            <Header />
            <div id="wrap">
                <Card
                    p={'var(--spacing-2xl)'}
                    gap={'var(--spacing-xl)'}
                >
                    <h1 className="h3 align-center">Oops!</h1>
                    <p className="m-0 align-center">Entschuldigung, ein unerwarteter Fehler ist aufgetreten.</p>
                    <span className="message error">
                        {error.statusText || error.message}
                    </span>
                    <Button
                        fullWidth
                        buttonType='primary'
                        onClick={() => navigate(-1)}
                    >Zurück</Button>
                </Card>
            </div>
        </>
    );
}